import { z } from 'zod'

// Weather data types — wire format for GET /api/weather response.
// Data sourced from QWeather (和风天气) or OpenWeatherMap fallback.

export const WeatherCurrent = z.object({
  temp: z.number(),
  feels_like: z.number(),
  humidity: z.number().int(),
  wind_speed: z.number(),
  wind_deg: z.number().int(),
  wind_scale: z.string().optional(),
  description: z.string(),
  icon: z.string(),
  rain_1h: z.number().optional(),
})
export type WeatherCurrent = z.infer<typeof WeatherCurrent>

export const WeatherForecastItem = z.object({
  dt: z.number().int(),
  temp: z.number(),
  feels_like: z.number(),
  humidity: z.number().int(),
  wind_speed: z.number(),
  wind_scale: z.string().optional(),
  description: z.string(),
  icon: z.string(),
  pop: z.number(),
})
export type WeatherForecastItem = z.infer<typeof WeatherForecastItem>

export const WeatherResponse = z.object({
  current: WeatherCurrent,
  forecast: z.array(WeatherForecastItem),
  location_name: z.string(),
  fetched_at: z.string(),
})
export type WeatherResponse = z.infer<typeof WeatherResponse>
